import SuperRepository from '../superRepository'

export default new (class organizationRepository extends SuperRepository {
  baseUri() {
    return 'organization'
  }

  syncOrganizationOneC = async () => this.httpClient().get(`${this.baseUri()}/synchronize`)
})()
